export default {
  header: {
    home: '首页',
    service: '我们的服务',
    product: '我们的产品',
    news: '最新消息',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    login: '登录',
    freeTrial: '免费体验',
  },
  foot: {
    freeTrialTitle: '立即免费试用',
    freeTrial: '免费体验',
    phoneLabel: '联系电话',
    addressLabel: '联系地址',
    address: '浙江省杭州市拱墅区祥园路28号6幢301室',
    wechatOfficial: '关注官方公众号',
    wechatOfficialDesc: '时刻掌握海外最新资讯',
    wechatService: '扫码添加运营专家',
    wechatServiceDesc: '帮你提供定制化最优方案',
    copyright: 'Copyright © 2026 杭州小五和她的兄弟们科技有限公司',
  },
  home: {
    slideTitle: '让内容出海更简单',
    slideSubtitle: '创作者都在用的出海服务平台',
    serviceTitle: '为创作者提供全方位的出海增长服务',
    serviceTitleH5: '为创作者提供全方位的<br>出海增长服务',
    processTitle: '合作流程',
    problemTitle: '常见问题',
    viewMore: '查看更多',
    collapse: '收起',
    partnerTitle: '合作伙伴',
    problems: [
      { title: '跟你们合作收费吗？', text: '全程免费合作，不获利轻松解约。' },
      { title: '签约后中途想解约怎么办？', text: '小五出海通提供人性化客户服务，实时关注你的需求，依照合同条款，全程协商，让解约不繁琐。' },
      { title: '签约后多久能获利？', text: '小五出海通根据各平台获利门槛进行内容定位，满足平台设置的获利门槛后，结合领域和账号发展情况，在 Youtube 获利约3-6个月，Facebook 约5-8个月，部分优质内容，仅需约一周即可获利。超过8个月无法开启获利，可以随时提出解约。' },
      { title: '自己做海外和找你们合作有什么区别？', text: '与小五出海通合作，可以最快速的开通获利，让你打击盗版更加高效便捷，出现账号级别相关问题，也可直接对接平台方解决，让出海更简单。' },
      { title: '我的内容有很多盗版，找你们能提供什么解决方案吗？', text: '小五出海通配备专业的版权保护团队，为你的内容提供从注册、监控到维权的全方位服务。让侵权者无处遁形，让你的创意安全无虞。' },
      { title: '个人账号在海外平台被封怎么办？', text: '我们提供专业团队服务，直通海外平台经理，及时解决账号问题，让出海高效便捷不头疼！' },
    ],
    services: [
      { title: '一键多平台分发', detailDes: '秒发全球热门平台，YouTube、Facebook、TikTok一网打尽（更多平台陆续接入中）' },
      { title: '智能版权保护监控', detailDes: '专业团队护航，让你的创意安全无虞。' },
      { title: '可视化收益工具管理', detailDes: '一站式全方位运营，涵盖内容策划到变现的所有环节，提供清晰透明的结算报表，支持多种收益模式，让你从多渠道获取稳定收益。' },
      { title: '运营专家1对1指导', detailDes: '提供全面化数据挖掘分析，帮你深入了解内容表现，量身定制个性化推广策略，最大化提升曝光率和收益潜力' },
      { title: '海外平台技术支持', detailDes: '对接海外平台经理，及时解决账号问题。' },
    ],
    partners: [
      { name: '@GuiGe', titText: '知名博主 · 粉丝数 1950万', des: '小五出海通是我接触下来最好的一个团队和平台，在服务的温度和理念上与我非常契合，客服团队给了我很多日常的陪伴与支持。在小五出海通的运营专家策略1V1指导下，我能深入了解自己创作的内容表现情况，选择最优创作方向。在小五出海通为我量身定制的个性化推广策略下，仅仅11个月便收获1000万以上的粉丝，让我对创作更有动力了！' },
      { name: '@萌萌与舞桐', titText: '知名博主 · 粉丝数 1840万', des: '选择小五出海通作为内容出海的代理商，除了让我的出海简单高效收益更可观之外，更是因为小五出海通能够很好地保障我的内容在海外的版权安全，让我专注创作。和小五合作仅14个月便收获了1000万以上粉丝的关注，上榜全球流量排行第6名。后续我将会更多利用平台提供的功能，持续提升内容的海外影响力，实现创收二合一。' },
      { name: '@陕北霞姐', titText: '知名博主 · 粉丝数 60.2万', des: '小五出海通签约流程简单便捷，弥补了中老年人对海外互联网平台的认知空缺。我非常感谢小五出海通这个团队给我提供的专业帮助和支持，帮我量身定制适合我的推广策略，让我这样的普通人创作的视频在海外得到广泛关注，也让中国传统美食工艺得到了跨国界的宣传和分享，收益变得更可观！' },
    ],
  },
  solution: {
    pageTitle: '为您提供行业领先解决方案',
    pageTitleH5: '为您提供<br>行业领先解决方案',
    freeTrial: '免费试用',
    painPointTitle: '行业痛点及解决方案',
    services: [
      {
        title: '短视频出海创收',
        detailTit: '爆款内容，轻松复制海外成功',
        detailDes: '只需轻轻一点，你的视频就能瞬间登陆 YouTube、Facebook、TikTok 等全球热门平台，瞬间开启“霸屏”模式！小五出海通，采用前沿技术，让你的内容轻松跨越国界，无论你是美食博主、旅行达人还是科技极客，都能在这里找到属于你的舞台。还有可视化收益管理工具，提供清晰透明的结算报表，使每一笔收入都清晰可查，让你对自己的财务状况了如指掌。更有专业团队负责结算事宜，确保收益安全无忧看的到！',
        list: [
          { title: '内容出海没方向，缺乏海外社媒平台运营经验？', des: '小五出海通有运营专家策略进行1V1指导，提供全面化数据分析，帮你深入了解内容的表现，不断优化创作方向，为你量身定制个性化推广策略。一键式分发海外社媒平台，最大化帮你的内容提升曝光率和收益潜力，让出海更简单，让收益更可观！' },
          { title: '内容出海，收益看不到？', des: '小五出海通提供可视化收益管理工具，简化流程提高效率，清晰透明的结算报表实时查收，让你的每一笔收入都清晰可查，对自己的财务状况了如指掌。更有专业团队负责结算事宜，确保你的收益安全无忧，既能看到也能收到！' },
        ],
      },
      {
        title: '短剧出海创收',
        detailTit: '定制化维权、社媒创收策略，助你打造现象级',
        detailDes: '原创不易，守护更需力量。小五出海通深知每一位创作者的心血与梦想，我们配备了专业的版权保护团队和智能版权系统，为你的内容提供从注册、监控到维权的全方位服务。让侵权者无处遁形，让你的创意安全无虞，不再烦恼版权问题，尽情享受创作的乐趣吧！',
        list: [
          { title: '短剧出海，内容盗版多怎么办？', des: '小五出海通配备有专业的版权保护团队和智能版权系统，为你的内容提供从注册、监控到维权的全方位服务。让侵权者无处遁形，让你的创意安全无虞，不再烦恼版权问题，尽情享受创作的乐趣吧！' },
          { title: '出海问题繁多，解决没头绪，平台反馈没效果？', des: '我们提供专业团队服务，直击海外平台经理，及时解决账号问题，让出海高效便捷不头疼！' },
        ],
      },
      {
        title: '影视内容出海创收',
        detailTit: '一站式本地化服务，让你的作品俘获全球观众',
        detailDes: '高效快节奏的浏览习惯，让长视频越来越不适合在社媒平台上进行广泛传播，为了更符合短视频的流行趋势，小五出海通可以通过技术化手段将你的影视内容制作成更利于传播的短视频，让你的内容在短视频时代继续爆款频出，持续产生内容收益。',
        list: [
          { title: '长视频在海外平台流量低能改善吗？', des: '小五出海通提供本土化服务，从内容策划到运营，结合各大平台流量规则，通过技术化手段将你的影视内容制作成更利于传播的短视频，让你的内容在短视频时代继续爆款频出，持续产生内容收益。开启片库剧行业第二春。' },
          { title: '大量长视频内容在多元海外平台规划无门？', des: '小五出海通为你量身定制个性化运营方案，轻松解决规划问题，让你的创收一步到位。出海更轻松！' },
        ],
      },
      {
        title: 'IP全球化运营',
        detailTit: '多元化变现渠道，让你的IP价值最大化',
        detailDes: '小五出海通建立有海外社媒营销矩阵，搭载独家智能优化算法，为你量身定制优化方案，让你的IP价值最大化，轻松提升海外影响力，同时我们挂靠海外头部社媒电商，为你提供多元化变现渠道，将内容、商品创收二合一，简单几步实现全球收益。',
        list: [
          { title: '如何扩大IP海外影响力？', des: '小五出海通建立海外社媒营销矩阵，为你量身定制优化方案，让你的IP价值最大化，轻松提升海外影响力。' },
          { title: 'IP商品在海外平台如何售卖？', des: '小五出海通挂靠海外头部社媒电商，将内容、商品创收二合一，简单几步帮你实现全球收益。' },
        ],
      },
    ],
  },
  aboutUs: {
    title: '关于我们',
    company: '杭州小五和她的兄弟们科技有限公司',
    desc1Suffix: '是一家致力于内容海外发行及为创作者增值创收的科技公司。',
    desc2: '以成为"领先的创作者出海服务平台"为愿景，通过自研算法、AIGC、智能化分析等前沿科技，不断提升互联网内容在创作、翻译、分发、推广及数据分析方面的运营效率。助力创作者、影视机构、IP、版权方出海，并携手探索内容的海外价值，开辟新的商业化路径。',
    brandNote: '*「小五兄弟」是「杭州小五和她的兄弟们科技有限公司」运营品牌',
    historyTitle: '发展历程',
    honorTitle: '荣誉',
    yearSuffix: '年',
    developments: [
      { time: '2017年', des: '小五兄弟于杭州、晋城两地创办成立' },
      { time: '2018年', des: '正式成为YouTube官方认证MCN机构' },
      { time: '2019年', des: '在香港注册分公司，成立香港办事部' },
      { time: '2020年', des: '成功入选YouTube全球优质供应商名录' },
      { time: '2020年', des: '荣获YouTube年度MCN伙伴称号' },
      { time: '2022年', des: '上榜Facebook优质案例库，获得业内首次官方推广' },
      { time: '2022年', des: '荣获YouTube年度最佳短影音运营奖' },
      { time: '2023年', des: '小五兄弟香港分公司升格为小五兄弟海外市场总部' },
      { time: '2023年', des: '荣获YouTube年度多格式创新运营奖' },
      { time: '2024年', des: '荣获五块YouTube钻石创作者奖牌' },
    ],
    honors: [
      { year: '2024年', text: '《YouTube钻石创作者》' },
      { year: '2023年', text: '《YouTube年度多格式创新运营奖》' },
      { year: '2022年', text: '《YouTube年度最佳短影音运营奖》' },
      { year: '2022年', text: '《Facebook优质合作伙伴》' },
      { year: '2020年', text: '《YouTube年度MCN伙伴》' },
    ],
  },
  resource: {
    pageTitle: '资源中心',
    knowledgeTitle: '内容出海知识库',
    searchPlaceholder: '搜索',
    searchButton: '搜索',
    introPrefix: '加入小五出海通，获取',
    introHighlight: '独家海外市场报告、爆款案例解析、平台算法秘籍',
    introSuffix: '等资源，助你在全球内容市场中脱颖而出！',
    trainingTitle: '培训活动',
    expandAll: '展开全部',
    collapse: '收起',
    goBack: '返回上一页',
    searchTooLong: '输入搜索内容,不可大于20字符！',
    searchEmpty: '请先输入搜索内容！',
    knowledgeEmpty: '{q}搜索，内容出海知识库 暂无数据',
    trainingEmpty: '{q}搜索，培训活动 暂无数据',
    searchSummary: '找到与"{q}"相关结果共 {n} 条',
    noResults: '暂无搜索结果',
    qrPromptLine1: '微信扫码打开【小五出海通】小程序',
    qrPromptLine2: '开启内容出海之旅',
  },
  common: {
    icp: '浙ICP备20027697号-11',
  },
}
